// color design tokens export
export const colorTokens = {
  grey: {
    0: "#FFFFFF",
    10: "#F6F6F6",
    50: "#F0F0F0",
    100: "#E0E0E0",
    200: "#C2C2C2",
    300: "#A3A3A3",
    400: "#858585",
    500: "#666666",
    600: "#4D4D4D",
    700: "#333333",
    800: "#1A1A1A",
    900: "#0A0A0A",
    1000: "#000000",
  },
  primary: {
    50:  "#E1F5EE",
    100: "#9FE1CB",
    200: "#5DCAA5",
    300: "#1D9E75",
    400: "#0F6E56",
    500: "#085041",
    600: "#04342C",
    700: "#0f1a13",
    800: "#0a1109",
    900: "#050a04",
  },
  secondary: {
    10:  "#fbfcfa",
    50:  "#f5f9f6",
    100: "#e6f3ec",
    200: "#c8e6d6",
    300: "#9FE1CB",
    400: "#1D9E75",
    500: "#0F6E56",
    600: "#0f1a13",
    700: "#0a1109",
    800: "#00353F",
    900: "#001519",
  },
};

export const themeSettings = (mode) => {
  return {
    palette: {
      mode: mode,
      ...(mode === "dark"
        ? {
            primary: {
              dark:  colorTokens.primary[100],
              main:  colorTokens.primary[300],
              light: colorTokens.primary[500],
            },
            neutral: {
              dark:       colorTokens.grey[100],
              main:       colorTokens.grey[200],
              mediumMain: colorTokens.grey[300],
              medium:     colorTokens.grey[400],
              light:      colorTokens.grey[700],
            },
            background: {
              default:        colorTokens.secondary[600],  // #0f1a13 — sidebar & navbar
              alt:            "#1e2d24",                   // dark mode body — lighter than sidebar, still dark green
              secondary:      colorTokens.secondary[400],
              secondary_dark: colorTokens.secondary[500],
            },
            secondary: {
              white:    colorTokens.secondary[10],
              sub_main: colorTokens.secondary[50],
              main:     colorTokens.secondary[400],
              medium:   colorTokens.secondary[300],
            },
          }
        : {
            primary: {
              dark:  colorTokens.primary[400],
              main:  colorTokens.primary[300],
              light: colorTokens.primary[50],
            },
            neutral: {
              dark:       colorTokens.grey[700],
              main:       colorTokens.grey[500],
              mediumMain: colorTokens.grey[400],
              medium:     colorTokens.grey[300],
              light:      colorTokens.grey[50],
            },
            background: {
              default:   colorTokens.secondary[600],  // #0f1a13 — sidebar & navbar
              alt:       colorTokens.grey[10],         // #F6F6F6 — light mode body, clearly lighter
              secondary: colorTokens.secondary[400],
            },
            secondary: {
              white:    colorTokens.secondary[10],
              sub_main: colorTokens.secondary[50],
              main:     colorTokens.secondary[400],
              medium:   colorTokens.secondary[300],
            },
          }),
    },
    typography: {
      fontFamily: ["DM Sans", "Rubik", "sans-serif"].join(","),
      fontSize: 12,
      h1: { fontFamily: ["DM Serif Display", "Rubik", "sans-serif"].join(","), fontSize: 40 },
      h2: { fontFamily: ["DM Serif Display", "Rubik", "sans-serif"].join(","), fontSize: 32 },
      h3: { fontFamily: ["DM Serif Display", "Rubik", "sans-serif"].join(","), fontSize: 24 },
      h4: { fontFamily: ["Rubik", "sans-serif"].join(","), fontSize: 20 },
      h5: { fontFamily: ["Rubik", "sans-serif"].join(","), fontSize: 16 },
      h6: { fontFamily: ["Rubik", "sans-serif"].join(","), fontSize: 14 },
    },
  };
};